import { render, staticRenderFns } from "./ExchangeRatesView.vue?vue&type=template&id=d413a88c&scoped=true"
import script from "./ExchangeRatesView.vue?vue&type=script&lang=js"
export * from "./ExchangeRatesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d413a88c",
  null
  
)

export default component.exports